import { JSX } from "react";

import InfoIconTooltip from "components/tooltip/InfoIconTooltip";
import { Loader } from "components/loader/Loader";
import { useRootStore } from "store";

import "./WizardModule.scss";

type Props = {
  showSaveButton?: boolean;
  onSaveClick?: () => void;
  children: JSX.Element;
  moduleTitle: string;
  info?: string | JSX.Element;
  collapsed?: boolean;
  hideLoader?: boolean;
};

export default function WizardModule({
  showSaveButton,
  onSaveClick,
  children,
  moduleTitle,
  info,
  collapsed,
  hideLoader
}: Props) {
  const { isLoading } = useRootStore((state) => state.wizard);

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    if (onSaveClick) {
      onSaveClick();
    }
  };

  const header = showSaveButton ? (
    <div className="moduleHeader" onClick={(e) => handleClick(e)}>
      <h2>{moduleTitle}</h2>
      <button>Klar</button>
    </div>
  ) : (
    <div className="moduleHeader">
      <div className="d-flex align-items-center">
        <h2 className="mr-3">{moduleTitle}</h2>
        {isLoading && !hideLoader && <Loader className="mt-2" />}
      </div>
      <div>
        <InfoIconTooltip text={info} />
      </div>
    </div>
  );

  return (
    <section className="module">
      {header}
      <div className="moduleContent">{children}</div>
    </section>
  );
}
